import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../..";

interface Props {
  allMessages: any[];
  originalNodeResponses: any;
  lastNodeResponse: any;
  typingStatus: string | any;
  sessionId: string | any;
  lastQuickActions: any[];
  lastInputBoxType: string | any;
  lastInputBoxStatus: boolean;
  botLanguage: string | any;
  isSessionIdFromLocalStorage: boolean;
  liveChatConnected: boolean;
  languageSelectionPopup: boolean;
  disableHeaderSelection: boolean;
  languageSelector: boolean;
  isSmartAIEnabled?: boolean;
}

let INITIAL_STATE: Props = {
  allMessages: [],
  originalNodeResponses: [],
  lastQuickActions: [],
  lastNodeResponse: null,
  lastInputBoxType: null,
  lastInputBoxStatus: false,
  typingStatus: "",
  sessionId: null,
  botLanguage: "english",
  isSessionIdFromLocalStorage: false,
  liveChatConnected:false,
  languageSelectionPopup: false,
  disableHeaderSelection: false,
  languageSelector: true,
  isSmartAIEnabled: false,
};

const AllMessagesSlice = createSlice({
  name: "AllMessagesSlice",
  initialState: INITIAL_STATE,
  reducers: {

    setAllMessages(state, { payload }: PayloadAction<any>) {
      if (!Array.isArray(payload) && typeof payload === "object") {
        payload = [payload];
      }
      const existingMsgs = JSON.parse(JSON.stringify(state.allMessages));
      const newMsgs = [...existingMsgs, ...payload];
      state.allMessages = newMsgs;
    },

    removeMessage(state, { payload }: PayloadAction<any>) {
      state.allMessages = state.allMessages?.filter(
        (message:any) => message?.message_id !== payload?.message_id
      );
    },

    setLanguageSelector(state, { payload }: PayloadAction<any>) {
      state.languageSelector = payload;
    },

    setLanguageSelectionPopup(state, { payload }: PayloadAction<any>) {
      state.languageSelectionPopup = payload;
    },

    setDisableHeaderSelection(state, { payload }: PayloadAction<any>) {
      state.disableHeaderSelection = payload;
    },

    updateMessage(state, { payload }: PayloadAction<any>) {
      console.log("payload to update message", payload);
      state.allMessages = state.allMessages?.map((message: any) =>
        message?.message_id === payload?.message_id
          ? { ...message, ...payload }
          : message
      );
    },

    setAllHistoryMessages(state, { payload }: PayloadAction<any>) {
      if (!Array.isArray(payload) && typeof payload === "object") {
        payload = [payload];
      }

      if (payload.length === 0) {
        state.allMessages = [];
        return;
      }

      state.allMessages = payload;
    },

    removeAllMessages() {
      return INITIAL_STATE;
    },

    removeAllMessagesForLanguage(state){
      // return {
      //   ...INITIAL_STATE,

      // }
      state.allMessages= [];
      state.originalNodeResponses= [];
      state.lastQuickActions= [];
      state.lastNodeResponse= null;
      state.lastInputBoxType= null;
      state.lastInputBoxStatus= false;
      state.typingStatus= "";
      state.sessionId= null;
      state.isSessionIdFromLocalStorage= false;
      state.liveChatConnected=false;
      return;
    },

    setTypingStatus(state, { payload }: PayloadAction<any>) {
      state.typingStatus = payload;
    },
    setLastNodeResponse(state, { payload }: PayloadAction<any>) {
      state.lastNodeResponse = payload;
      state.lastInputBoxStatus = payload?.["input"] ? true : false;
      state.lastInputBoxType = payload?.["input"] && payload?.["input_type"]
        ? payload?.["input_type"]
        : null;
      state.lastQuickActions = payload?.["quickActions"]?.length > 0
        ? payload?.["quickActions"]
        : [];
    },

    setOriginalResponses(state, { payload }: PayloadAction<any>) {
      const existingResponses = JSON.parse(
        JSON.stringify(state.originalNodeResponses)
      );
      const newResponses = [...existingResponses, payload];
      state.originalNodeResponses = newResponses;
    },

    setSessionId(state, { payload }: PayloadAction<any>) {
      state.sessionId = payload;
    },

    setBotLanguage(state, { payload }: PayloadAction<any>) {
      state.botLanguage = payload;
    },
    setIsSessionIdFromLocalStorage(state, { payload }: PayloadAction<any>) {
      state.isSessionIdFromLocalStorage = payload;
    },
    setLiveChatConnected(state, { payload }: PayloadAction<any>) {
      state.liveChatConnected = payload;
    },
    setIsSmartAIEnabled(state, { payload }: PayloadAction<any>) {
      console.log("payload in setIsSmartAIEnabled", payload);
      if(!payload?.enabled && payload?.type !== "user-query") return;
      state.isSmartAIEnabled = true;
    },
  },
});

export default AllMessagesSlice.reducer;

export const {
  removeAllMessages,
  setAllMessages,
  removeMessage,
  updateMessage,
  setAllHistoryMessages,
  setTypingStatus,
  setSessionId,
  setLastNodeResponse,
  setOriginalResponses,
  setBotLanguage,
  setIsSessionIdFromLocalStorage,
  setLiveChatConnected,
  removeAllMessagesForLanguage,
  setLanguageSelectionPopup,
  setDisableHeaderSelection,
  setLanguageSelector,
  setIsSmartAIEnabled
} = AllMessagesSlice.actions;

export const allMessagesStore = (state: RootState) =>
  state.botData.currrentAllMessagesStore;

export const getLanguageSelectionPopup = (state: RootState) =>
  state.botData.currrentAllMessagesStore.languageSelectionPopup;

export const getDisableHeaderSelection = (state: RootState) =>
  state.botData.currrentAllMessagesStore.disableHeaderSelection;

export const getLanguageSelector = (state: RootState) =>
  state.botData.currrentAllMessagesStore.languageSelector;

export const getIsSmartAIEnabled = (state: RootState) =>
  state.botData.currrentAllMessagesStore.isSmartAIEnabled;